import { render, staticRenderFns } from "./ClariveinPage.vue?vue&type=template&id=7c7ef4ad&scoped=true"
import script from "./ClariveinPage.vue?vue&type=script&lang=js"
export * from "./ClariveinPage.vue?vue&type=script&lang=js"
import style0 from "./ClariveinPage.vue?vue&type=style&index=0&id=7c7ef4ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7ef4ad",
  null
  
)

export default component.exports